import styles from './Subheader.module.css';

export const ListingsSubheader = ({ children }) => {
  return (
    <div className={`sub-header-search ${styles.container}`}>{children}</div>
  );
};
